<template>
  <div :style="customStyle" class="aretv sedna-transit panels-grid">
    <template v-if="dataIsLoaded">
      <TransitItem
        v-for="(journey, idx) in (journeys || destinations)"
        :key="idx"
        :time="journey.travelTime"
        :destinationLabel="journey.label"
      />
    </template>
    <p v-else class="loader">Fetching transit info...</p>
  </div>
</template>

<script>
  /**
   * Test using thus URL (Warsaw office + lunch places nearby):
   * http://localhost:8080/transit?location=52.227799,20.992899&destination=52.226307,20.982894%3BByd%C5%82o%20i%20powid%C5%82o&destination=52.235757,20.990526%3BMiss%20Kimchi&destination=52.219454,21.01729%3BTuk%20Tuk&destination=52.232758,21.013509%3BBarnBurger
   */

  import axios from 'axios'
  import TransitItem from './TransitItem'
  const API_KEY = 'n4VvYvkQnxnFZuqmyWGq6Vrnh9BTB_JOEOQt-teMhIM'
  const API_URL = 'https://route.ls.hereapi.com/routing/7.2/calculateroute.json'

  export default {
    name: 'Transit',
    components: { TransitItem },
    props: {
      customStyle: { type: Object, default: () => {} },
      customColor: { type: String, default: '' },
      customBackground: { type: String, default: '' }
    },
    data () {
      return {
        dataIsLoaded: false,
        location: '', // geolocation of the screen/kiosk, e.g. '52.5,13.4'
        destinations: [], // data decoded from URL query
        journeys: [] // `destinations` data plus journey time taken from transit API
      }
    },
    mounted () {
      const queryString = window.location.search // TODO: maybe use $route.params instead?
      const urlParams = new URLSearchParams(queryString)
      this.location = urlParams.get('location')

      urlParams.getAll('destination').map((item) => {
        const bits = item.split(';', 2)
        const destination = {
          location: bits[0],
          label: bits[1]
        }
        this.destinations.push(destination)
      })

      const apiRequests = []
      const component = this
      this.destinations.map((destination) => {
        const params = {
          apiKey: API_KEY,
          waypoint0: `geo!${component.location}`,
          waypoint1: `geo!${destination.location}`,
          mode: 'fastest;car;traffic:disabled'
        }
        apiRequests.push(axios.get(`${API_URL}`, { params }).then((response) => {
          const data = response.data.response
          const route = data.route[0]
          const summary = route.summary
          return {
            ...destination,
            travelTime: summary.travelTime, // seconds
            trafficTime: summary.trafficTime, // seconds
            distance: summary.distance // meters
          }
        }))
      })

      Promise.all(apiRequests).then((values) => {
        component.journeys = values
        component.dataIsLoaded = true
      })
    }
  }
</script>

<style>
  .aretv.sedna-transit {
    font-family: 'AvenirNext LT Pro', Helvetica, sans-serif;
    padding: 75px 97px;
  }
  .panels-grid, .sedna-sports {
    display: flex;
    justify-content: space-around;
  }
</style>